import React from 'react';
import { TFormContext } from './_types';

export default React.createContext<TFormContext | undefined>(undefined);
